import axios, { AxiosStatic } from 'axios';
import store from '@/store';

import {
  REMOVE_APIKEY,
  GET_TOKEN,
  REMOVE_TOKEN,
  REMOVE_REFRESH_TOKEN,
  GET_REFRESH_TOKEN,
  SET_TOKEN,
  SET_REFRESH_TOKEN,
} from '@/store/modules/auth/types';

declare module 'vue/types/vue' {
  interface Vue {
    $http: AxiosStatic;
  }
  interface VueConstructor {
    $http: AxiosStatic;
  }
}

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const httpRefreshToken = async () => {
  const refresh_response = await http.post('/auth/refresh', {
    refresh_token: store.getters[`auth/${GET_REFRESH_TOKEN}`],
  });

  store.dispatch(`auth/${SET_TOKEN}`, refresh_response.data.token);
  store.dispatch(
    `auth/${SET_REFRESH_TOKEN}`,
    refresh_response.data.refresh_token
  );

  return refresh_response;
};

export default {
  install(Vue: any) {
    http.interceptors.request.use((config) => {
      if (store.getters[`auth/${GET_TOKEN}`]) {
        config.headers.Authorization = `Bearer ${
          store.getters[`auth/${GET_TOKEN}`]
        }`;
      }
      return config;
    });

    http.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response.status !== 401) {
          throw error;
        }

        if (
          error.config.url === '/auth/refresh' ||
          error.config.url === '/auth/invalidate' ||
          error.config.url === '/auth'
        ) {
          store.dispatch(`auth/${REMOVE_APIKEY}`);
          store.dispatch(`auth/${REMOVE_TOKEN}`);
          store.dispatch(`auth/${REMOVE_REFRESH_TOKEN}`);
          throw error;
        }

        try {
          await httpRefreshToken();

          return http.request(error.config);
        } catch (e) {
          throw e;
        }
      }
    );

    Vue.prototype.$http = http;
  },
};
